export default (state) => {
  if (!state.billingsubscriptions) {
    return undefined;
  }

  const { nextBillDt } = state.billingsubscriptions;

  return nextBillDt;
};
